import { Action, createReducer, on } from '@ngrx/store';
import { MetadataConfigurationState } from '../state/metadata-configuration.state';
import {
    addAcceptanceIdentifier,
    getMetadataConfigurationFailure,
    getMetadataConfigurationSuccess,
    resetMetadataConfiguration,
    sortAcceptanceIdentifiers,
    updateAcceptanceIdentifier,
    updateExpirationDateConfiguration
} from '../actions/metadata-configuration.actions';

const getInitialState = (): MetadataConfigurationState => ({
    documentTypeId: undefined,
    acceptanceIdentifiers: undefined,
    isEditable: undefined,
    expirationDateConfiguration: undefined,
    isDirty: undefined,
    error: undefined
});

const reducer = createReducer(
    getInitialState(),

    on(getMetadataConfigurationSuccess, (state, action) => ({
        ...state,
        documentTypeId: action.metadataConfiguration.documentTypeId,
        acceptanceIdentifiers: action.metadataConfiguration.acceptanceIdentifiers,
        isEditable: action.metadataConfiguration.isEditable,
        expirationDateConfiguration: action.metadataConfiguration.expirationDateConfiguration,
        isDirty: false,
        error: undefined
    })),

    on(getMetadataConfigurationFailure, (state, action) => ({
        ...state,
        documentTypeId: undefined,
        acceptanceIdentifiers: undefined,
        expirationDateConfiguration: undefined,
        isEditable: undefined,
        isDirty: undefined,
        error: action.error
    })),

    on(addAcceptanceIdentifier, (state, action) => ({
        ...state,
        acceptanceIdentifiers: [...state.acceptanceIdentifiers, action.acceptanceIdentifier],
        isDirty: true
    })),

    on(updateAcceptanceIdentifier, (state, action) => ({
        ...state,
        acceptanceIdentifiers: state.acceptanceIdentifiers.map((ai) =>
            ai.fieldName === action.acceptanceIdentifier.fieldName ? { ...action.acceptanceIdentifier } : ai
        ),
        isDirty: true
    })),

    on(updateExpirationDateConfiguration, (state, action) => ({
        ...state,
        acceptanceIdentifiers: state.acceptanceIdentifiers.map((ai) =>
            ai.fieldName === action.acceptanceIdentifier.fieldName ? { ...action.acceptanceIdentifier } : ai
        ),
        expirationDateConfiguration: action.expirationDateConfiguration,
        isDirty: true
    })),

    on(sortAcceptanceIdentifiers, (state, action) => ({
        ...state,
        acceptanceIdentifiers: action.acceptanceIdentifiers.map((ai, i) => ({
            ...ai,
            sortOrder: i + 1
        })),
        isDirty: true
    })),

    on(resetMetadataConfiguration, () => getInitialState())
);

export function metadataConfigurationReducer(state: MetadataConfigurationState | undefined, action: Action) {
    return reducer(state, action);
}
